import { render, staticRenderFns } from "./AlertDialog.vue?vue&type=template&id=024f595a&scoped=true"
import script from "./AlertDialog.vue?vue&type=script&lang=js"
export * from "./AlertDialog.vue?vue&type=script&lang=js"
import style0 from "./AlertDialog.vue?vue&type=style&index=0&id=024f595a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "024f595a",
  null
  
)

export default component.exports